import styled, { css, DefaultTheme, SimpleInterpolation, ThemedStyledProps } from 'styled-components';

import { VisitSettlementStatus } from '@dreryk/egabinet-financial-settlement-frontend-api';

import { assertUnreachable } from '@dreryk/react-common';

type StyledVisitSettlementStatusIconProps = {
   $status: VisitSettlementStatus | null;
};

const resolveFill = ({
   theme,
   $status,
}: ThemedStyledProps<StyledVisitSettlementStatusIconProps, DefaultTheme>): SimpleInterpolation | null => {
   switch ($status) {
      case 'SETTLED_CORRECTLY':
         return css`
            fill: ${theme.success};
         `;
      case 'SETTLED_WITHOUT_MEDICAL_SERVICES':
         return css`
            fill: ${theme.warning};
         `;
      case 'SETTLED_INCORRECTLY':
         return css`
            fill: ${theme.error};
         `;
      case 'UNSETTLED':
         return css`
            fill: ${theme.textBody};
         `;
      case null:
         return null;
      default:
         return assertUnreachable($status);
   }
};

export const StyledVisitSettlementStatusIcon = styled.div<StyledVisitSettlementStatusIconProps>`
   display: flex;
   justify-content: center;
   height: 20px;

   > svg {
      ${resolveFill};
      width: 20px;
      height: 20px;
   }
`;

StyledVisitSettlementStatusIcon.displayName = 'StyledVisitSettlementStatusIcon';
